import React from "react";
import { Typography, Row, Col, Avatar, theme, Space } from "antd";
import { UserOutlined, MailOutlined, PhoneOutlined, ShopOutlined } from "@ant-design/icons";
import type { ProviderData } from "../types";

const { Title, Text } = Typography;

interface ProviderDetailsProps {
  provider: ProviderData;
}

const ProviderDetails: React.FC<ProviderDetailsProps> = ({ provider }) => {
  const { token } = theme.useToken();

  return (
    <div style={{ padding: "0 8px 32px" }}>
      {/* ── Cover / Header Area ── */}
      <div
        style={{
          background: `linear-gradient(135deg, ${token.colorBgBase} 0%, ${token.colorPrimaryBgHover} 100%)`,
          padding: "32px 24px",
          borderRadius: token.borderRadiusLG,
          marginBottom: 32,
          border: `1px solid ${token.colorBorderSecondary}`,
          display: "flex",
          flexDirection: "column",
          gap: 16,
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div style={{ position: "absolute", top: -20, right: -20, opacity: 0.05, fontSize: 180 }}>
          <ShopOutlined />
        </div>

        <Space size={16} align="center">
          <Avatar
            size={72}
            icon={<UserOutlined />}
            shape="square"
            style={{
              backgroundColor: token.colorPrimaryBg,
              color: token.colorPrimary,
              borderRadius: token.borderRadiusLG,
            }}
          />
          <div>
            <Title level={3} style={{ margin: 0, fontWeight: 800, color: token.colorTextHeading }}>
              {provider.name_provider}
            </Title>
            <Text type="secondary" style={{ fontSize: 14 }}>
              Perfil de Proveedor
            </Text>
          </div>
        </Space>
      </div>

      {/* ── Information Grid ── */}
      <Row gutter={[24, 24]}>
        {/* Contacto Block */}
        <Col xs={24} sm={12}>
          <div
            style={{
              background: token.colorBgContainer,
              border: `1px solid ${token.colorBorderSecondary}`,
              borderRadius: token.borderRadiusLG,
              padding: 24,
              height: "100%",
              boxShadow: token.boxShadowTertiary
            }}
          >
            <Text type="secondary" style={{ fontSize: 12, textTransform: "uppercase", fontWeight: 700, letterSpacing: 1, display: "block", marginBottom: 16 }}>
              Correo Electrónico
            </Text>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ background: token.colorFillAlter, padding: 12, borderRadius: "50%", display: "flex" }}>
                <MailOutlined style={{ fontSize: 20, color: token.colorTextDescription }} />
              </div>
              <div>
                <Text style={{ display: "block", fontSize: 13, color: token.colorTextSecondary }}>Principal</Text>
                <Text strong style={{ fontSize: 16 }}>{provider.email_provider || "No especificado"}</Text>
              </div>
            </div>
          </div>
        </Col>

        {/* Telefono Block */}
        <Col xs={24} sm={12}>
          <div
            style={{
              background: token.colorBgContainer,
              border: `1px solid ${token.colorBorderSecondary}`,
              borderRadius: token.borderRadiusLG,
              padding: 24,
              height: "100%",
              boxShadow: token.boxShadowTertiary
            }}
          >
            <Text type="secondary" style={{ fontSize: 12, textTransform: "uppercase", fontWeight: 700, letterSpacing: 1, display: "block", marginBottom: 16 }}>
              Teléfono de Contacto
            </Text>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ background: token.colorFillAlter, padding: 12, borderRadius: "50%", display: "flex" }}>
                <PhoneOutlined style={{ fontSize: 20, color: token.colorTextDescription }} />
              </div>
              <div>
                <Text style={{ display: "block", fontSize: 13, color: token.colorTextSecondary }}>Móvil / Fijo</Text>
                <Text strong style={{ fontSize: 16 }}>
                  {provider.phone_number_provider || "No disponible"}
                </Text>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProviderDetails;
